/**
 * セット企画設定画面　セット企画プロモーション商品情報VOクラス
 */
export class KYMW1312SetPlanPromotionGoodsRegistModel {

  // Ｐコード
  public pCode: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';

  // 生協コード
  public coopCode: string = <string>'';
  // セット企画商品名
  public setDelivGoodsName: string = <string>'';

  // セット企画商品名（カナ）
  public setDelivGoodsNameKana: string = <string>'';

  // セット企画規格名
  public setDelivStandardName: string = <string>'';

  // セット企画規格名（カナ）
  public setDelivStandardNameKana: string = <string>'';

  // セット企画区分
  public setPlanDiv: string = <string>'';

  // 単品注文可否区分
  public singleOrderFlag: string = <string>'';

  // 注文受付可否区分
  public acceptDiv: string = <string>'';

  // 供給可能区分
  public supplyDiv: string = <string>'';

  // セット企画数量
  public approvedNum: string = <string>'';

  // 成立価格
  public approvedPrice: string = <string>'';

}
